<template>
  <div class="uk-width-1-1 uk-grid-margin">
    <p
      v-if="permissionEnabled(1)"
      :class="{'uk-text-danger': $v.form.waiver.$invalid && $v.form.waiver.$dirty || formError('waiver', true)}"
    >
      <label><input
        v-model="$v.form.waiver.$model"
        :type="waiverInputType"
        value="1"
        true-value="1"
        false-value="0"
        name="waiver"
        :disabled="disabled"
      > <span v-html="$t('events.permission_waiver_public')" /></label>
    </p>
    <p
      v-if="permissionEnabled(2)"
      :class="{'uk-text-danger': $v.form.waiver.$invalid && $v.form.waiver.$dirty || formError('waiver', true)}"
    >
      <label><input
        v-model="$v.form.waiver.$model"
        :type="waiverInputType"
        value="2"
        true-value="2"
        false-value="0"
        name="waiver"
        :disabled="disabled"
      > <span v-html="$t('events.permission_waiver_private')" /></label>
    </p>
    <p
      v-if="permissionEnabled(3)"
      :class="{'uk-text-danger': $v.form.waiver.$invalid && $v.form.waiver.$dirty || formError('waiver', true)}"
    >
      <label><input
        v-model="$v.form.waiver.$model"
        :type="waiverInputType"
        value="3"
        true-value="3"
        false-value="0"
        name="waiver"
        :disabled="disabled"
      > <span v-html="$t('events.permission_waiver_group')" /></label>
    </p>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Watch, Mixins } from "vue-property-decorator";
import FormStep from "./FormStep";
import EventModel from "../../models/EventModel";
import EventEntryModel from "../../models/EventEntryModel";

@Component({
  validations: {
    form: {
      waiver: {
        checked: value => parseInt(value) > 0
      }
    }
  }
})
export default class PermissionStep extends Mixins(FormStep) {
  @Prop({default: 0}) readonly value!: number;
  @Prop() readonly entry!: EventEntryModel;
  data(): any {
    return {
        form: {
          waiver: this.value,
        }
    }
  }

  get event(): EventModel {
    return this.$store.getters["events/byId"](this.entry?.data.event_id);
  }

  get waiverInputType(): string {
    return this.event.meta.permissions.enabled.length == 1 ? "checkbox" : "radio";
  }

  permissionEnabled(n: number): boolean {
    return this.event.meta.permissions.enabled.indexOf(n) > -1;
  }

  @Watch("form.waiver", {immediate: true})
  waiverIsValid(v: string): void {
    this.$emit("input", parseInt(v));
  }
}
</script>

<style scoped>

</style>
